import React, { Component } from 'react'
import SideBar from '@components/JiaMeng/SideBar'
import VideoCover from '@UI/VideoCover'
import { PreviewModal } from 'hlj-components'

const VIDEO_URL = '//qnvideo.hunliji.com/o_1csqd2eaecbofmb1hbp1g04qfbu.mp4'

export default class extends Component {
  state = {
    visible: false
  }

  toggle = () => {
    this.setState({ visible: !this.state.visible })
  }

  render() {
    return (
      <SideBar>
        <div style={{ color: '#333' }}>水镜有什么作用</div>
        <div style={{ color: '#666', marginTop: 10 }}>
          在新人到店之后，商家可以通过水镜
          展示的优美案例为新人介绍产品，提高成单率，也可以显示店铺实力，降低培训成本。
        </div>
        <div style={{ color: '#333', marginTop: 20 }}>快速了解水镜系统</div>

        <VideoCover
          cover={`${VIDEO_URL}?vframe/jpg/offset/0`}
          onClick={this.toggle}
        />
        <a
          style={{ marginTop: 10, display: 'inline-block' }}
          onClick={() =>
            window.open(
              '//m.hunliji.com/p/wedding/Public/wap/m/business-school-detail/index.html?id=101'
            )
          }
        >
          了解更多使用方法
        </a>

        <PreviewModal visible={this.state.visible} onCancel={this.toggle}>
          <video src={VIDEO_URL} controls />
        </PreviewModal>
      </SideBar>
    )
  }
}
